// extracted by mini-css-extract-plugin
export var cell = "_4p-4";
export var headerCell = "_4p-2";
export var rowHeader = "_4p-3";
export var table = "_4p-1";
export var tableContainer = "_4p-0";